import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';

import controller from './bulk-archive-generated-report-instances-dialog.controller';
import template from './bulk-archive-generated-report-instances-dialog.html';

import bulkArchiveGeneratedReportInstance from './bulkArchiveGeneratedReportInstance';
import bulkArchiveGeneratedReportInstancesConfirmDialog from '../dialog.bulkArchiveGeneratedReportInstancesConfirmDialog';

class dialogService {
  getOptions($event, { reportType, reportInstances }) {
    return {
      controller,
      controllerAs: 'bulkArchiveGeneratedReportInstancesDialogVM',
      locals: {
        reportType,
        reportInstances,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.reports.generatedReports.reportType.bulkArchiveGeneratedReportInstancesDialog', [
  ngCookies,
  constants,
  reportsDataService,
  ssDialogService,
  alerts,
  loaderService,
  bulkArchiveGeneratedReportInstance,
  bulkArchiveGeneratedReportInstancesConfirmDialog,
])
  .service('bulkArchiveGeneratedReportInstancesDialog', dialogService)
  .name;
